import Splide from "@splidejs/splide";
import axios from "axios";


let gap = '2rem';
let padding = '3rem';
const API_URL = `${window.location.origin}/nuovo-sito-meetravel/wp-json/wp/v2`

let carouselsConfig = {
    'experiences-carousel': {
        pagination: false,
        type: 'loop',
        padding: padding,
        gap: gap,
        mediaQuery: 'min',
        breakpoints: {
            768: {
                perPage: 3,
                rewind: true,
                autoWidth: true,
                autoHeight: true,
            }
        }
    },
    'reviews-carousel': {
        pagination: false,
        type: 'loop',
        gap: gap,
        padding: padding,
        mediaQuery: 'min',
        breakpoints: {
            768: {
                rewind: true,
                fixedWidth: '600px',
                fixedHeight: '500px',
            },
        }
    },
    'traveltypes-carousel': {
        pagination: false,
        type: 'loop',
        padding: padding,
        gap: gap,
        mediaQuery: 'min',
        breakpoints: {
            768: {
                perPage: 4,
                fixedWidth: '20rem',
                rewind: true,
            },
        }
    },
}


document.addEventListener('DOMContentLoaded', function() {
    let carouselsToMount = Array.from(document.getElementsByClassName('splide')); // Converte HTMLCollection in un array

    for (let carousel of carouselsToMount) {
        const configType = carousel.dataset.configtype;
        console.log(configType)
        new Splide(carousel, carouselsConfig[configType]).mount()
        console.log(carouselsConfig[configType])
    }

});


export const fetchCards = async (cardType) => {
    try {
        let params = {
            'card_type': cardType.termId,
            '_embed': 'true'
        }
        const response = await axios.get(`${API_URL}/meetravel_card`, {params});
        return response.data;
    } catch (error) {
        console.error('Error fetching cards:', error);
    }
};

export const fetchTerms = async () => {
    let response = await axios.get(API_URL + "/card_type")
    let terms = []
    response.data.forEach((term) => {
       terms.push({termId : term.id, name : term.name})
    })
    return terms
}

export const removeHtmlTags = (str) => {
    if (!str) return '';
    return str.replace(/<[^>]*>?/gm, '');
};

export const fetchSponsors = async (cardType, params = {}) => {
    let response = await axios.get(`${API_URL}/${cardType}`, params)
    console.log(response.data)

    return response.data
}


